import { Typography, Stack, Link, InsertLinkOutlinedIcon, Instagram } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function UserSocialMediaLinks({ ig, links }) {
    const isMobile = useIsMobile();
    const font = isMobile ? "body2" : "body3";

    const formatUrl = (link) =>
        link.startsWith("http://") || link.startsWith("https://")
            ? link
            : `https://${link}`;

    const getInstagramUrl = () => 
        `https://instagram.com/${ig}/`;

    if (!links || links.length === 0) {
        return (
        <Typography variant={font} color="text.secondary">
            None
        </Typography>
        );
    }

    return (
        <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ height: 'auto' }}>

            {ig && (
                <Link
                    href={getInstagramUrl()}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="small"
                    color="primary"
                    sx={{ display: 'flex', alignItems: 'center' }}
                    onClick={(e) => e.stopPropagation()}
                    >
                        <Instagram sx={{ fontSize: '16px' }} />
                </Link>
            )}

            {links.map((link, idx) => (
                <Link
                    key={idx}
                    href={formatUrl(link)}
                    target="_blank"
                    rel="noopener noreferrer"
                    size="small"
                    color="primary"
                    sx={{ display: 'flex', alignItems: 'center' }}
                    onClick={(e) => e.stopPropagation()}
                    >
                        <InsertLinkOutlinedIcon sx={{ fontSize: '16px' }} />
                </Link>
            ))}
        </Stack>
    );
}
